"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Collapse = _interopRequireDefault(require("../collapse/Collapse"));

var _classnames = _interopRequireDefault(require("classnames"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ExpanderPanel = function ExpanderPanel(props) {
  var bsStyle = props.bsStyle,
      className = props.className,
      iconLeft = props.iconLeft,
      title = props.title,
      headerClassName = props.headerClassName,
      titleClassName = props.titleClassName,
      bodyClassName = props.bodyClassName,
      mountOnEnter = props.mountOnEnter,
      unmountOnExit = props.unmountOnExit,
      onEnter = props.onEnter,
      onEntering = props.onEntering,
      onEntered = props.onEntered,
      onExit = props.onExit,
      onExiting = props.onExiting,
      onExited = props.onExited,
      children = props.children,
      onToggle = props.onToggle,
      open = props.open;

  var _useState = (0, _react.useState)(open),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1]; // Update internal state from external prop change


  (0, _react.useEffect)(function () {
    setIsOpen(open);
  }, [open]);

  var handleToggle = function handleToggle() {
    var newState = !isOpen;
    setIsOpen(newState);
    onToggle(newState);
  };

  var wrapperClassNames = (0, _classnames.default)('expander-panel panel', "panel-".concat(bsStyle), className);
  var iconClassNames = (0, _classnames.default)('expander-icon', 'rioglyph', 'rioglyph-chevron-down');
  var headerClassNames = (0, _classnames.default)('panel-heading', isOpen && 'open', iconLeft && 'icon-left', headerClassName && headerClassName);
  var titleClassNames = (0, _classnames.default)('title', titleClassName && titleClassName);
  var bodyClassNames = (0, _classnames.default)('panel-body', bodyClassName && bodyClassName);
  var isRenderCallback = children && typeof children === 'function';
  return /*#__PURE__*/_react.default.createElement("div", {
    className: wrapperClassNames
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: headerClassNames,
    onClick: handleToggle
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: titleClassNames
  }, title), /*#__PURE__*/_react.default.createElement("span", {
    className: iconClassNames
  }), bsStyle === 'separator' && /*#__PURE__*/_react.default.createElement("div", {
    className: 'separator'
  }, /*#__PURE__*/_react.default.createElement("hr", null))), /*#__PURE__*/_react.default.createElement(_Collapse.default, {
    in: isOpen,
    mountOnEnter: mountOnEnter,
    unmountOnExit: unmountOnExit,
    onEnter: onEnter,
    onEntering: onEntering,
    onEntered: onEntered,
    onExit: onExit,
    onExiting: onExiting,
    onExited: onExited
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: bodyClassNames
  }, isRenderCallback ? children(isOpen) : children))));
};

ExpanderPanel.defaultProps = {
  mountOnEnter: true,
  unmountOnExit: true,
  bsStyle: 'blank',
  iconLeft: false,
  open: false,
  onToggle: function onToggle() {},
  onEnter: function onEnter() {},
  onEntering: function onEntering() {},
  onEntered: function onEntered() {},
  onExit: function onExit() {},
  onExiting: function onExiting() {},
  onExited: function onExited() {}
};
ExpanderPanel.propTypes = {
  className: _propTypes.default.string,
  headerClassName: _propTypes.default.string,
  titleClassName: _propTypes.default.string,
  bodyClassName: _propTypes.default.string,
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,
  bsStyle: _propTypes.default.oneOf(['blank', 'default', 'separator', 'primary', 'secondary', 'info', 'warning', 'danger', 'success']),
  iconLeft: _propTypes.default.bool,
  open: _propTypes.default.bool,
  mountOnEnter: _propTypes.default.bool,
  unmountOnExit: _propTypes.default.bool,
  onToggle: _propTypes.default.func,
  onEnter: _propTypes.default.func,
  onEntering: _propTypes.default.func,
  onEntered: _propTypes.default.func,
  onExit: _propTypes.default.func,
  onExiting: _propTypes.default.func,
  onExited: _propTypes.default.func,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func])
};
var _default = ExpanderPanel;
exports.default = _default;